import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React from "react";

const CustomViewTable = ({
    allValues,
    editingRows,
    onRowEditChange,
    rowEditValidator,
    handleSave,
    columns,
    actions,
}) => {
    return (
        <DataTable
            className="col-12 properties-table-list table-error-align"
            value={allValues}
            editMode="row"
            dataKey="id"
            editingRows={editingRows}
            onRowEditChange={onRowEditChange}
            rowEditValidator={rowEditValidator}
            onRowEditSave={handleSave}
            tableStyle={{ minWidth: "50rem" }}
        >
            {columns?.map((col, index) => {
                return (
                    <Column
                        key={index}
                        field={col?.accessor}
                        header={col?.name}
                        editor={col?.editor}
                        headerClassName="custom-header"
                        body={col?.body}
                    // style={{ width: "25%" }}
                    ></Column>
                )
            })}
            {actions && <Column
                header="Action"
                rowEditor
                headerClassName="custom-header"
                body={(rowData, options) => actions(rowData, options)}
            ></Column>}
        </DataTable>
    )
}

export default CustomViewTable